import * as React from 'react';
import { useEffect } from 'react';
import { ErrorMessage, Grid } from 'ui-toolkit';
import { AssociatedLendersContainer } from '../../components/clients/AssociatedLendersContainer';
import { ClientDetailsHeader } from '../../components/clients/ClientDetailsHeader';
import { clientNavigationOptions } from '../../router/admin/ClientLenderCompaniesRouter';
import { useSelector } from 'react-redux';
import { RootStore } from '../../store/types';
import { useAppDispatch } from '../../store/store';
import { getAllClientsAsyncAction } from 'store/clients/clientsSlice';
import { getAllLendersAsyncAction } from 'store/lenders/lendersSlice';
import { useParams } from 'react-router-dom';
import { UUID } from '../../types/shared/UUID';
import { useListClientsQuery } from '../../API/clients/ClientCompanyApi';

export const ClientAssociatedLendersPage: React.FC = () => {
  const { clientId } = useParams<{ clientId: UUID }>();
  const dispatch = useAppDispatch();
  const { clients, lenders } = useSelector((store: RootStore) => store.usersCollection);
  const { data: allClients = [] } = useListClientsQuery({ includeDeactivated: true });
  const company = allClients.find((company) => company.id === clientId);

  useEffect(() => {
    dispatch(getAllClientsAsyncAction());
    dispatch(getAllLendersAsyncAction());
  }, [dispatch]);

  const updateListOfLenders = () => dispatch(getAllLendersAsyncAction());

  const fetchError = clients.fetchError || lenders.fetchError;

  return (
    <Grid>
      <ErrorMessage message={fetchError?.message} />
      <ClientDetailsHeader
        clientId={clientId}
        companyName={company ? company.name : clientId}
        currentPageLink={clientNavigationOptions(clientId)[1].to || ''}
      />
      <AssociatedLendersContainer
        clientId={clientId}
        lendersFetchStatus={lenders.fetchStatus}
        lenders={lenders.data}
        updateListOfLenders={updateListOfLenders}
      />
    </Grid>
  );
};
